import ClinicIntegrationEdit from './ClinicIntegrationEdit.vue'

export default {
  name: 'ClinicIntegrationsTab',
  props: ['clinic_id'],
  components: {
    ClinicIntegrationEdit,
  },
  data: () => ({
    loading: false,
    integrations: [],
    tableIntegrations: null,
    isEdit: false,
    selectedIntegration: null,
  }),
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData: async function() {
      this.loading = true
      NProgress.start()
      try {
        let response = await this.$clinicService.listIntegrations({clinicId: this.clinic_id})
        this.integrations = response.result ? response.result : []
        this.tableIntegrations = {
          'items': this.integrations,
          'columns': [
            {name: this.$i18n.t('integration.name'), type: 'string', value: 'name', width: '40%'},
            {name: this.$i18n.t('integration.type'), type: 'string', value: 'type', width: '30%'},
            {name: this.$i18n.t('integration.statusCol'), type: 'custom', key: 'status', width: '30%'},
          ]
        }
      } catch (err) {
        console.log(err)
        this.$message.popup(this, 'request_error', 'operationFail', 'error')
      }
      NProgress.done(true)
      this.loading = false
    },
    toDetails(values) {
      if (!values || !values.item) {
        return
      }
      this.selectedIntegration = values.item
      this.isEdit = true
    },
    newIntegration() {
      this.selectedIntegration = null
      this.isEdit = true
    },
    cancelEdit() {
      this.selectedIntegration = null
      this.isEdit = false
    },
    onSaved() {
      this.selectedIntegration = null
      this.isEdit = false
      this.fetchData()
    },
  }
}
